const MESSAGES_BASE_ROUTE = '/messages';

export const MESSAGES_ROUTES = {
  messages: MESSAGES_BASE_ROUTE,
};
